export default __webpack_public_path__ + "9e6cc4ac66e79fa88645bcd04e4b1e56.png";